import request from '@/utils/request';

/**
 * 提现记录
 * @param params 参数
 */
export const getCloudOrders = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/live/yun/orders',
    method: 'get',
    params,
  });
